import api from "../utils/apiClient";

export const saveConfigHandle = async (data) => {
    const {storeHash, fileType, fileUrl} = data;

    const appConfigRes = await api.get(`/api/app-configs?storeHash=${storeHash}`);
    const configs = appConfigRes.data;
    const appConfig = Array.isArray(configs) && configs.length > 0 ? configs[0] : null;

    if (!appConfig || !appConfig.id) {
        throw new Error("No app config found for this storeHash");
    }
    const appConfigUri = `/api/app_configs/${appConfig.id}`;
    localStorage.setItem("appConfigId", appConfig.id);

    const res = await api.patch(
        appConfigUri,
        JSON.stringify({fileType, fileUrl}),
        {
            headers: {
                "Content-Type": "application/merge-patch+json",
            },
        }
    );

    return res.data;
};

export const getConfigByStoreHash = async (storeHash) => {
    try {
        const response = await api.get(`/api/app-configs?storeHash=${storeHash}`);
        const configs = response.data;
        return Array.isArray(configs) && configs.length > 0 ? configs[0] : null;
    } catch (error) {
        console.error('Error fetching config by store hash:', error);
        throw error;
    }
};

export const getConfigHandle = async () => {
    try {
        const {data} = await api.get('/api/app_configs');
        return Array.isArray(data.member) && data.member.length > 0 ? data.member[0] : null;
    } catch (error) {
        if (error.response?.status === 404) {
            return null;
        }
        console.error('Error fetching config:', error);
        throw error;
    }
};

export const updateConfigHandle = async (configId, configData) => {
    try {
        const response = await api.patch(`/api/app_configs/${configId}`, configData, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error updating config:', error);
        throw error;
    }
};
